"use client"

import { Toaster } from "@/components/ui/toaster"

export function ToastProvider() {
  return <Toaster />
}
